// extracted by mini-css-extract-plugin
export default {"modalContent":"CommonPopup_modalContent__G3c+W","infoText":"CommonPopup_infoText__TTBDP"};